import { render } from "./MovieDetailView.vue?vue&type=template&id=619dd5f1"
import script from "./MovieDetailView.vue?vue&type=script&lang=js"
export * from "./MovieDetailView.vue?vue&type=script&lang=js"

import "./MovieDetailView.vue?vue&type=style&index=0&id=619dd5f1&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__